import type * as SchemaTypes from '../types';

import type { UserCompanyContextDataFragment } from './UserCompanyContextData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { LanguagePackContextDataFragment } from './LanguagePackContextData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import type { AvailableModulesDataFragment } from './AvailableModulesData';
import type { CompanyDealerDataFragment } from './CompanyDealerData';
import type { MaintenanceUpdateFragment } from './MaintenanceUpdate';
import type { SimpleVersioningDataFragment } from './SimpleVersioningData';
import type { AuthorData_CorporateCustomer_Fragment, AuthorData_ExternalBank_Fragment, AuthorData_Guarantor_Fragment, AuthorData_LocalCustomer_Fragment, AuthorData_Salesforce_Fragment, AuthorData_SystemBank_Fragment, AuthorData_User_Fragment } from './AuthorData';
import type { UserAvatarSpecsFragment } from './UserAvatarSpecs';
import type { EdmEmailFooterPublicDataFragment } from './EdmEmailFooterPublicData';
import type { EdmSocialMediaDataFragment } from './EdmSocialMediaData';
import { gql } from '@apollo/client';
import { UserCompanyContextDataFragmentDoc } from './UserCompanyContextData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { LanguagePackContextDataFragmentDoc } from './LanguagePackContextData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
import { AvailableModulesDataFragmentDoc } from './AvailableModulesData';
import { CompanyDealerDataFragmentDoc } from './CompanyDealerData';
import { MaintenanceUpdateFragmentDoc } from './MaintenanceUpdate';
import { SimpleVersioningDataFragmentDoc } from './SimpleVersioningData';
import { AuthorDataFragmentDoc } from './AuthorData';
import { UserAvatarSpecsFragmentDoc } from './UserAvatarSpecs';
import { EdmEmailFooterPublicDataFragmentDoc } from './EdmEmailFooterPublicData';
import { EdmSocialMediaDataFragmentDoc } from './EdmSocialMediaData';
export type CurrentUserCompaniesDataFragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id'>
  & { availableCompanies: Array<(
    { __typename: 'Company' }
    & UserCompanyContextDataFragment
  )> }
);

export const CurrentUserCompaniesDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUserCompaniesData on User {
  id
  availableCompanies(companyId: $companyId) {
    ...UserCompanyContextData
  }
}
    `;